<template>
  <div name="reportcard">

    <div
      class="bg-gray-200 absolute mt-4 ml-4 font-sans w-3/12 flex flex-row justify-center items-center"
    >
  
      <div class="card w-full mx-auto bg-white shadow-xl hover:shadow">
        
        <div
          class="w-24 h-24 bg-gray-300 pt-6 text-xl text-center mx-auto rounded-full -mt-20 border-8 border-white"
        >
          {{ getPupilInitials(pupil) }}
        </div>
        <div class="text-center mt-2 text-2xl font-medium">{{ pupil.name }}</div>

        <div v-if="componentLoaded"  class="text-center mt-2 w-10/12 mx-auto font-light text-sm">
          <table class="text-left bg-gray-300 w-full ">
            <tr>
              <td>Units Assessed:</td>
              <td class="text-center"> <span class="font-bold">{{ assessmentCount}}</span> </td>
            </tr>
            <tr v-for="row in criteriaList" :key="row.key" class="my-2 even:bg-gray-200" >
                   <td>{{ row.value }}</td>
                    <td  class="text-center"> <span v-html="showGrade(row)"></span></td>
            </tr>
          </table>

          <div class="mt-6 font-bold">Final Grade: <span class="mx-2" v-html="finalGrade"></span></div>
        </div>
 
        <hr class="mt-8" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import { ReportingService } from "@/services/reporting.service";

export default {
  name: "reportcard",
  props: {
    pupil: { type: Object, required: true },
    calendar: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings"
    }),
    componentLoaded() {
      return this.loading === false
    },
    criteriaList() {
      if (this.settings.assessmentCriteriaList.length > 0) {
        return this.settings.assessmentCriteriaList.filter((c) => c.used === true );
      }
    },
    assessmentCount() {
      return this.assessments != undefined ? this.assessments.length : 0
    },
    gradesList() {
      return this.settings.assessmentGradesList.filter((c) => c.used === true );
    },
    finalGrade() {
      var value = "n/a"
      if (this.grades.final_grade != undefined) {
        value = parseFloat(this.grades.final_grade).toFixed(2)
      }

      return '<span style="background-color:#' + this.setGradeColor(value) + ';" class="p-3 px-2 rounded  text-white">' + value + '</span>'
    }
  },
  data() {
    return {
      loading: true,
      erroed: false,
      assessments: [],
      grades: undefined
    };
  },
  mounted() {
    this.getCurriculum();
  },
  methods: {
    getPupilInitials(pupil) {
      return pupil.name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .substring(0, 3);
    },
    getCurriculum() {
      ReportingService.getCurriculumByPupil(this.pupil, this.calendar.value)
        .then((response) => this.parseCurriculum(response.data))
        .catch((err) => {
          console.log("Activities " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    parseCurriculum(data) {
      this.grades = data.curriculum.grades != undefined ? data.curriculum.grades : []
      this.assessments = data.assessments != undefined ? data.assessments : []
    },
    showGrade(criteria) {
      const result = this.grades
      if (result === null) { return }
      
        var gradeFound = "n/a"
        switch (criteria.key) {
          case "criteria_1":
            if (result.criteria_1) {
              gradeFound = result.criteria_1
            }
            break;
          case "criteria_2":
            if (result.criteria_2) {
              gradeFound =  result.criteria_2
            }
            break;
          case "criteria_3":
            if (result.criteria_3) {
              gradeFound =  result.criteria_3
            }
            break;
          case "criteria_4":
            if (result.criteria_4) {
              gradeFound =  result.criteria_4
            }
            break;
          case "criteria_5":
            if (result.criteria_5) {
              gradeFound =  result.criteria_5
            }
            break;
          default:
            return "n/a";
            break;
        }

        let gradeDisplay = Number.isInteger(gradeFound) ? gradeFound.toFixed(2) : 0
        return gradeFound ? '<span style="background-color:#' + this.setGradeColor(gradeFound) + ';" class="p-1 px-2 rounded text-white">' + gradeDisplay + '</span>' : "n/a"
    },
    gradeFromScore(score) {
      const rounded = (score != undefined && score != "n/a" &&  Number.isInteger(score) === true) ? parseFloat(score).toFixed(0) : 0
      let grade = this.gradesList.filter((g) => {
        return parseInt(rounded) === g.score
      })

      return grade
    },
    setGradeColor(score) {
      let grade = this.gradeFromScore(score)
      return grade.length > 0 ? grade[0].color : 'ffffff'
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
